<script setup>
import { trans, transChoice } from 'laravel-vue-i18n';

defineProps({
    type: {
        type: String,
        default: 'div',
    },
});
const reviews = [
    {
        name: 'Chacha Go',
        initial: 'C',
        color: 'orange-600',
        date: '2026-06-01',
        stars: 5,
        review: 'partners.subscriptions.review.1',
    },
    {
        name: 'Bombina D',
        initial: 'B',
        color: 'green-600',
        date: '2026-05-25',
        stars: 5,
        review: 'partners.subscriptions.review.2',
    },
    {
        name: 'Aurore Folny',
        initial: 'A',
        color: 'blue-600',
        date: '2026-04-01',
        stars: 5,
        review: 'partners.subscriptions.review.3',
    },
];
</script>
<template>
    <div class="py-5">
        <h2 class="text-xl font-bold mb-6 text-center">
            {{ trans('Notes et avis') }}
        </h2>
        <div class="flex flex-col gap-8  text-center sm:text-left max-w-xl mx-auto">

            <div v-for="review in reviews" :key="review.name"
                class="flex flex-col gap-2 sm:gap6 p-4 bg-white/50 border-1 border-cyan-500 rounded-xl dark:text-[#1d2b33]">
                <div class="flex flex-col sm:flex-row items-center sm:gap-3">
                    <span
                        class="inline-flex justify-center items-center h-12 w-12 sm:h-8 sm:w-8 text-white rounded-full" :class="'bg-'+[review.color]">{{ review.initial}}</span>
                    <h3 class="font-bold mb-0 text-sm whitespace-nowrap">{{review.name}}</h3>
                </div>
                <div class="flex flex-col sm:flex-row items-center sm:gap-3 mb-1">
                    <div class="flex flex-row items-center gap-1">
                        <svg v-for="star in review.stars" class="h-3 w-3 fill-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><polygon points="15 .73 19.31 10.58 30 11.63 21.97 18.77 24.27 29.27 15 23.83 5.73 29.27 8.03 18.77 0 11.63 10.69 10.58 15 .73" stroke-width="0" /></svg>
                    </div>
                    <div class="text-xs whitespace-nowrap">{{review.date}}</div>
                </div>
                <p class="text-sm">{{ trans(review.review) }}</p>
            </div>

        </div>
</div></template>
